

<div id="container" *ngIf="curso$ | async as curso; else loading">
    <mat-card>
        <mat-card-header>
            <mat-card-subtitle>Por: {{curso.creador}}</mat-card-subtitle>
            <mat-card-title>{{curso.titulo}}</mat-card-title>
            
        </mat-card-header>

        <div class="container">
            <img  [src]="curso.imagen">
        </div>

        
        <mat-card-content>
            <pre wrap="hard">{{curso.content}}</pre>
        </mat-card-content>
       
        <mat-card-footer>
            <mat-toolbar id="tol">
                
                <span>
                    {{curso.vistas}}<i class="fa fa-eye" aria-hidden="true"></i>
                </span>
                
                <span class="fill-remaining-space"></span>
                <span>
                    <a href="https://twitter.com/intent/tweet?text={{curso.titulo}}&url={{link}}&hashtags=LeyDeMurphy,Nota" target="_blank"><i class="fa fa-twitter fa-2x" aria-hidden="true"></i></a>
                </span>
                &nbsp;&nbsp;
            </mat-toolbar>
        </mat-card-footer>
    

    </mat-card>
</div>




<div id="Comentarios" *ngIf="curso$ | async as curso;">

    <div id="comentario">
    
        <mat-label>Mensaje</mat-label>
        <input style="width: 70%;" #message maxlength="256" [(ngModel)]="comentarioo">
        <mat-hint>{{message.value.length}} / 256</mat-hint>
    
        &nbsp;&nbsp;
        <button mat-raised-button color="accent" class="fill-remaining-space" (click)="enviarComentario(curso,comentarioo)">Enviar</button>    
          
    </div>


    <mat-card *ngFor="let comentario of curso.comentarios">
        <mat-card-content>
            <pre wrap="hard">{{comentario}}</pre>
        </mat-card-content>
    </mat-card>
</div>



 <ng-template #loading>
    
    <div id="load">
    
         <div class="container-spinner">
            <mat-spinner color="accent"></mat-spinner>
         </div>
         <!-- <img src="../../../assets/spinner.gif" alt="" id="imagenSpin"> -->
     </div>
</ng-template>

